import React from 'react';
import _ from 'lodash';
import {useDispatch} from 'react-redux';
import CameraMisc from '../miscs/CameraMisc';
import {Vehicle, ViewMode, Camera} from '../types';
import { changeViewMode } from '../actions';
import Checkbox from './Checkbox';
import SearchInput from './SearchInput';
import VehicleComponent from './VehicleComponent';

type Props = {
  vehicles: Map<string, Vehicle>,
  cameras: Map<string, Camera>,
  selected: Map<string, Camera>,
  searchValue: string,
  viewMode: ViewMode[]
}

const LeftPanel = ( props: Props ) => {
  const {vehicles, viewMode, selected} = props;
  const searchValue = props.searchValue.toLocaleLowerCase();
  const dispatch = useDispatch();
  let vehiclesToDisplay: Vehicle[] = [];
  vehicles.forEach( ( value: Vehicle ) => {
    if ( searchValue.length && !value.title.toLowerCase().includes( searchValue ) ) {
      return;
    }
    if ( !viewMode.includes( ViewMode.active ) || !viewMode.includes( ViewMode.inactive ) ) {
      if ( !viewMode.length ) {
        return;
      }
      const cameraStatus = CameraMisc.getCameraStatusByVehicle( value );
      if ( viewMode.includes( ViewMode.active ) && !cameraStatus.active ) {
        return;
      } else if ( viewMode.includes( ViewMode.inactive ) && !cameraStatus.inactive ) {
        return;
      }
    }
    vehiclesToDisplay.push( value );
  });
  vehiclesToDisplay = _.orderBy( vehiclesToDisplay, ['title'], ['asc'] );

  return (
    <section className='LeftPanel'>
      <div className='logo'>
      </div>
      <div className='LeftPanel-inner'>
        <SearchInput searchValue={props.searchValue} />
        <section className='viewMode-section row'>
          <div className='active col'>
            <Checkbox
              checked={viewMode.includes( ViewMode.active )}
              onToggle={ ( _toggleTo: boolean ) => dispatch( changeViewMode( ViewMode.active ) ) }
            />
            <i className='icon icon-green-camera'/>
          </div>
          <div className='inactive col'>
            <Checkbox
              checked={viewMode.includes( ViewMode.inactive )}
              onToggle={ ( _toggleTo: boolean ) => dispatch( changeViewMode( ViewMode.inactive ) ) }
            />
            <i className='icon icon-grey-camera'/>
          </div>
        </section>
        <section className='vehicle-tree-section'>
          { vehiclesToDisplay.map( (singleVehicle: Vehicle) => {
            return <VehicleComponent
              key={`veh${singleVehicle.id}`}
              vehicle={ singleVehicle }
              viewMode={viewMode}
              selected={selected}
            />
          }) }
        </section>
      </div>
    </section>
  );
}

export default LeftPanel;
